import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import {
  defaultMetaObj,
  initialUserDashboardStateState,
} from "store/constants";
import { NotificationManager } from "react-notifications";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";

const { userDashboardStateEndPoint } = endPoints;

export const fetchUserDashboardState = createAsyncThunk(
  "userDashboardState/fetchUserDashboardState",
  async (
    { page, searchParamsObj = {} }: { page: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      endpoint: userDashboardStateEndPoint,
      searchParams: {
        ...searchParamsObj,
      },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserDashboardState = createAsyncThunk(
  "userDashboardState/updateUserDashboardState",
  async ({ updatedData, dashboardId }: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.update(
        userDashboardStateEndPoint,
        dashboardId,
        updatedData
      );
      if (response.status === 204) {
        // NotificationManager.success("updated Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const userDashboardStateSlice = createSlice({
  name: "userDashboardState",
  initialState: initialUserDashboardStateState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch user dashboard state
    builder
      .addCase(fetchUserDashboardState.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchUserDashboardState.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.userDashboardState = action.payload?.objects[0] as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchUserDashboardState.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.meta = defaultMetaObj;
        }
      );

    //   update user dashboard state
    builder
      .addCase(updateUserDashboardState.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        updateUserDashboardState.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        updateUserDashboardState.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const userDashboardStateReducer = userDashboardStateSlice.reducer;
